// Studyo Today Backend
// Package studyo.today.subscriptions.v1.resources
// Resource definitions
// Copyright (c) 2015-2021 Intuitic Inc.

// @generated by protoc-gen-es v2.2.5 with parameter "import_extension=js"
// @generated from file studyo/today/subscriptions/v1/resources/entitlement.proto (package studyo.today.subscriptions.v1.resources, syntax proto3)
/* eslint-disable */

import { enumDesc, fileDesc, tsEnum } from "@bufbuild/protobuf/codegenv1";

/**
 * Describes the file studyo/today/subscriptions/v1/resources/entitlement.proto.
 */
export const file_studyo_today_subscriptions_v1_resources_entitlement = /*@__PURE__*/
  fileDesc("CjlzdHVkeW8vdG9kYXkvc3Vic2NyaXB0aW9ucy92MS9yZXNvdXJjZXMvZW50aXRsZW1lbnQucHJvdG8SJ3N0dWR5by50b2RheS5zdWJzY3JpcHRpb25zLnYxLnJlc291cmNlcyqxAQoLRW50aXRsZW1lbnQSGwoXRU5USVRMRU1FTlRfVU5TUEVDSUZJRUQQABIjCh9FTlRJVExFTUVOVF9FWFRFUk5BTF9DT05ORUNUT1JTEAESIQodRU5USVRMRU1FTlRfVEVBQ0hFUl9EQVNIQk9BUkQQAhIeChpFTlRJVExFTUVOVF9TSEFSRURfU0NIT09MUxADEh0KGUVOVElUTEVNRU5UX0NPTVBBU1NfU1RFUFMQBEIvqgIsU3R1ZHlvLlRvZGF5LlN1YnNjcmlwdGlvbnMuR3JwYy5WMS5SZXNvdXJjZXNiBnByb3RvMw");

/**
 * Describes the enum studyo.today.subscriptions.v1.resources.Entitlement.
 */
export const EntitlementSchema = /*@__PURE__*/
  enumDesc(file_studyo_today_subscriptions_v1_resources_entitlement, 0);

/**
 * Represents something that the user is allowed to do based on his current subscription plan.
 *
 * @generated from enum studyo.today.subscriptions.v1.resources.Entitlement
 */
export const Entitlement = /*@__PURE__*/
  tsEnum(EntitlementSchema);

